import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const LegendZoomButton = ({ isZoomIn, onClick, inActive }) => (
   <button
      onClick={onClick}
      className={
         classNames('legend-zoom-icon', {
            'legend-zoom-icon__zoom-in': isZoomIn,
            'legend-zoom-icon__inactive': inActive
         })
      }
      aria-label={isZoomIn ? 'Zoom in' : 'Zoom out'}
   />
);

LegendZoomButton.propTypes = {
   isZoomIn: PropTypes.bool,
   onClick: PropTypes.func
};

export default LegendZoomButton;
